import React, { useEffect, createContext, useRef } from 'react'
import { getDocumentTitle, setDocumentTitle } from 'src/helpers/browser'

export const ActiveOverlayContext = createContext()

const initialState = {
  activeId: null,
  inactiveIds: []
}

const updateOverlayStateReducer = (state, { id, data }) => {
  const update = { ...state }
  const inactive = update.inactiveIds

  if (data) {
    update.activeId && inactive.unshift(update.activeId)
    update.activeId = id
    update[id] = data
  } else {
    const index = inactive.indexOf(id)
    index > -1 && inactive.splice(index, 1)
    if (update.activeId === id && inactive.length > 0) {
      update.activeId = inactive[0]
    }
    delete update[id]
  }
  return update
}

export const ActiveOverlayContextProvider = props => {
  const fromTitle = useRef(getDocumentTitle())
  const [overlayState, updateOverlayState] = React.useReducer(
    updateOverlayStateReducer,
    initialState
  )

  useEffect(() => {
    const resetTitle = fromTitle.current
    const stateData = overlayState[overlayState.activeId]
    if (overlayState.length) {
      setDocumentTitle(`Homebot - ${stateData.title}`)
    } else {
      setDocumentTitle(resetTitle)
    }
  }, [overlayState])

  const value = { overlays: overlayState, updateOverlayState }

  return (
    <ActiveOverlayContext.Provider value={value}>
      {props.children}
    </ActiveOverlayContext.Provider>
  )
}
